export const FIXED_REMOVAL_FEE_PECENTAGE = 3